import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListSelect from '../../shared/components/ListSelect';
import {
  fetchCustomers,
  setActiveCustomerAndFetchLinkedUsers,
} from '../../shared/reducers/client';
import { StoreDispatch, StoreState } from '../store';
import * as styles from '../styles/form.module.scss';
import { CompanyIcon } from './icons';

const CustomerSelect: React.FC = () => {
  const dispatch = useDispatch<StoreDispatch>();
  const customers = useSelector((state: StoreState) => state.client.customers);
  const logoSrc = useSelector(
    (state: StoreState) => state.branding.partnerLogoSrc,
  );

  useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  const availableCustomers = customers.map((c) => {
    return {
      title: c.company,
      text: `${c.firstName} ${c.lastName}`,
      value: c.id,
    };
  });

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <img alt='Logo' className={styles.logo} src={logoSrc} />
        <div className={styles.form}>
          <div className={styles.form_content}>
            <h2 className={styles.title_small}>
              Select the account you&apos;d like to use
            </h2>
            <div className={styles.form_body}>
              <ListSelect
                items={availableCustomers}
                itemSelected={(value) => {
                  dispatch(setActiveCustomerAndFetchLinkedUsers(value));
                }}
                icon={CompanyIcon}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSelect;
